import { render } from "./multipleChoicesQuestion.vue?vue&type=template&id=f0a65512&scoped=true"
import script from "./multipleChoicesQuestion.vue?vue&type=script&lang=js"
export * from "./multipleChoicesQuestion.vue?vue&type=script&lang=js"

import "./multipleChoicesQuestion.vue?vue&type=style&index=0&id=f0a65512&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a65512"]])

export default __exports__